document.addEventListener('DOMContentLoaded', async () => {
  const USA = 'UNITED STATES';
  const stockistsDataElement = document.getElementById('stockists-data');
  const stockistsContainer = document.getElementById('stockists-container'); // For localized strings
  const stockistCountriesContainer = document.getElementById('stockist-countries');
  const stockistCountryList = stockistCountriesContainer
    ? stockistCountriesContainer.querySelector('.stockist-country-list')
    : null;
  const stockistDetailsContainer = document.getElementById('stockist-details'); // Overall container for details section
  const stockistStateSelectorContainer = document.getElementById('stockist-state-selector-container');
  const stockistStateSelectorList = document.getElementById('stockist-state-selector-list');
  const stockistListContent = document.getElementById('stockist-list-content'); // Specific area for stockist listings
  const pageTitleElement = document.querySelector('.stockists-page__title');
  const originalPageTitle = pageTitleElement
    ? pageTitleElement.dataset.originalTitle || pageTitleElement.textContent
    : 'Our Stockists';

  if (
    !stockistsDataElement ||
    !stockistCountryList ||
    !stockistDetailsContainer ||
    !stockistsContainer ||
    !stockistStateSelectorContainer ||
    !stockistStateSelectorList ||
    !stockistListContent
  ) {
    console.error('Stockists page critical elements not found.');
    if (stockistListContent) {
      const message = stockistsContainer
        ? stockistsContainer.dataset.noStockistsAvailable || 'No stockists available at the moment.'
        : 'No stockists available at the moment.';
      stockistListContent.innerHTML = `<p>${message}</p>`;
    }
    if (pageTitleElement) pageTitleElement.textContent = originalPageTitle; // Reset title
    return;
  }

  const localizedStrings = {
    no_stockists_in_country: stockistsContainer.dataset.noStockistsInCountry || 'No stockists found in this country.',
    no_stockists_available: stockistsContainer.dataset.noStockistsAvailable || 'No stockists available at the moment.',
    no_stockists_in_state: 'No stockists found in this state.', // Added for US states
    loading: stockistListContent.textContent, // Preserve initial loading message if needed
  };

  let stockists = [];
  try {
    const initialStockists = JSON.parse(stockistsDataElement.textContent);
    stockists.push(...initialStockists);

    let nextUrl = stockistsDataElement.dataset.nextUrl;

    while (nextUrl) {
      try {
        const response = await fetch(nextUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const pageDataElement = doc.getElementById('stockists-data');

        if (pageDataElement) {
          const pageStockists = JSON.parse(pageDataElement.textContent);
          if (pageStockists && Array.isArray(pageStockists)) {
            stockists.push(...pageStockists);
          }
          nextUrl = pageDataElement.dataset.nextUrl;
        } else {
          console.error('Could not find stockists data on fetched page:', nextUrl);
          nextUrl = null;
        }
      } catch (error) {
        console.error('Error fetching next page of stockists:', error);
        nextUrl = null;
      }
    }
  } catch (e) {
    console.error('Error parsing stockists data:', e);
    stockistListContent.innerHTML = '<p>Error loading stockist data.</p>';
    if (pageTitleElement) pageTitleElement.textContent = originalPageTitle; // Reset title
    return;
  }

  if (!Array.isArray(stockists) || stockists.length === 0) {
    stockistListContent.innerHTML = `<p>${localizedStrings.no_stockists_available}</p>`;
    if (stockistCountriesContainer) stockistCountriesContainer.style.display = 'none';
    if (pageTitleElement) pageTitleElement.textContent = originalPageTitle; // Reset title
    return;
  }

  const stockistsByCountry = stockists.reduce((acc, stockist) => {
    const country = stockist.country || 'Unknown Country';
    if (!acc[country]) {
      acc[country] = [];
    }
    acc[country].push(stockist);
    return acc;
  }, {});

  const allCountryNames = Object.keys(stockistsByCountry);

  if (allCountryNames.length === 0) {
    stockistListContent.innerHTML = `<p>${localizedStrings.no_stockists_available}</p>`;
    if (stockistCountriesContainer) stockistCountriesContainer.style.display = 'none';
    if (pageTitleElement) pageTitleElement.textContent = originalPageTitle; // Reset title
    return;
  }

  // Prepare sorted list with USA first
  let orderedDisplayCountries = allCountryNames.filter((c) => c !== USA).sort();
  const hasUnitedStates = allCountryNames.includes(USA);
  if (hasUnitedStates) {
    orderedDisplayCountries.unshift(USA);
  }

  stockistCountryList.innerHTML = ''; // Clear any existing (e.g. from placeholder)

  function addCountryButton(countryName, parentList) {
    const li = document.createElement('li');
    const button = document.createElement('button');
    button.textContent = countryName;
    button.dataset.country = countryName;
    button.classList.add('stockist-country-button');
    button.type = 'button';
    button.addEventListener('click', () => displayStockistsForCountry(countryName));
    li.appendChild(button);
    parentList.appendChild(li);
    return button;
  }

  orderedDisplayCountries.forEach((country, index) => {
    addCountryButton(country, stockistCountryList);
    if (country === USA && orderedDisplayCountries.length > 1 && index === 0) {
      const hr = document.createElement('hr');
      hr.classList.add('stockist-country-separator');
      stockistCountryList.appendChild(hr);
    }
  });

  function renderStockistItem(stockist) {
    const listItem = document.createElement('li');
    listItem.classList.add('stockist-item');

    let addressHtml = `<strong>${stockist.name || 'N/A'}</strong>`;
    addressHtml += `${stockist.address_1 || ''}<br>`;
    if (stockist.address_2) {
      addressHtml += `${stockist.address_2}<br>`;
    }
    addressHtml += `${stockist.city || ''}`;
    if (stockist.state) {
      addressHtml += `, ${stockist.state}`;
    }
    if (stockist.postal_code) {
      addressHtml += ` ${stockist.postal_code}`; // Added space before postal code
    }
    addressHtml += `<br>${stockist.country || ''}`;
    listItem.innerHTML = addressHtml;
    return listItem;
  }

  function generateStateId(stateName) {
    return `stockist-state-${stateName.replace(/\s+/g, '-').toLowerCase()}`;
  }

  function displayStockistsForCountry(country) {
    if (pageTitleElement) {
      pageTitleElement.textContent = `${originalPageTitle} in ${country}`;
    }

    stockistCountryList.querySelectorAll('.stockist-country-button').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.country === country);
    });

    // Clear previous state selector and content
    stockistStateSelectorList.innerHTML = '';
    stockistStateSelectorContainer.style.display = 'none';
    stockistListContent.innerHTML = '';

    const stockistsInCountry = stockistsByCountry[country] || [];

    if (stockistsInCountry.length === 0) {
      stockistListContent.innerHTML = `<p>${localizedStrings.no_stockists_in_country}</p>`;
      return;
    }

    if (country === USA) {
      const stockistsByState = stockistsInCountry.reduce((acc, stockist) => {
        const state = stockist.state || 'Unknown State';
        if (!acc[state]) acc[state] = [];
        acc[state].push(stockist);
        return acc;
      }, {});

      const states = Object.keys(stockistsByState).sort();
      if (states.length === 0) {
        // Should not happen if stockistsInCountry is not empty
        stockistListContent.innerHTML = `<p>${localizedStrings.no_stockists_in_country}</p>`;
        return;
      }

      states.forEach((state) => {
        const stateId = generateStateId(state);
        const stateContainer = document.createElement('div');
        stateContainer.classList.add('stockist-state-group');
        stateContainer.id = stateId;

        const stateHeading = document.createElement('h3');
        stateHeading.classList.add('stockist-state-name');
        stateHeading.textContent = state;
        stateContainer.appendChild(stateHeading);

        const stockistsInState = stockistsByState[state] || [];
        if (stockistsInState.length === 0) {
          const noStockistsInStateMsg = document.createElement('p');
          noStockistsInStateMsg.textContent = localizedStrings.no_stockists_in_state;
          stateContainer.appendChild(noStockistsInStateMsg);
        } else {
          const stockistsInStateByCity = stockistsInState.reduce((acc, stockist) => {
            const city = stockist.city || 'Unknown City';
            if (!acc[city]) acc[city] = [];
            acc[city].push(stockist);
            return acc;
          }, {});

          const cities = Object.keys(stockistsInStateByCity).sort();
          cities.forEach((city) => {
            const cityContainer = document.createElement('div');
            cityContainer.classList.add('stockist-city-group');

            const cityHeading = document.createElement('h4'); // City heading under State
            cityHeading.classList.add('stockist-city-name');
            cityHeading.textContent = city;
            cityContainer.appendChild(cityHeading);

            const stockistListForCity = document.createElement('ul');
            stockistListForCity.classList.add('stockist-list');
            stockistsInStateByCity[city].forEach((stockist) => {
              stockistListForCity.appendChild(renderStockistItem(stockist));
            });
            cityContainer.appendChild(stockistListForCity);
            stateContainer.appendChild(cityContainer);
          });
        }
        stockistListContent.appendChild(stateContainer);
      });

      // Populate and show state selector if there are states
      if (states.length > 0) {
        states.forEach((state) => {
          const stateId = generateStateId(state);
          const li = document.createElement('li');
          const anchor = document.createElement('a');
          anchor.href = `#${stateId}`;
          anchor.textContent = state;
          anchor.addEventListener('click', (event) => {
            event.preventDefault();
            const targetElement = document.getElementById(stateId);
            if (targetElement) {
              targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
          li.appendChild(anchor);
          stockistStateSelectorList.appendChild(li);
        });
        stockistStateSelectorContainer.style.display = 'block';
      }
    } else {
      // For countries other than United States
      const stockistsByCity = stockistsInCountry.reduce((acc, stockist) => {
        const city = stockist.city || 'Unknown City';
        if (!acc[city]) acc[city] = [];
        acc[city].push(stockist);
        return acc;
      }, {});

      const cities = Object.keys(stockistsByCity).sort();
      cities.forEach((city) => {
        const cityContainer = document.createElement('div');
        cityContainer.classList.add('stockist-city-group');

        const cityHeading = document.createElement('h3'); // Original city heading level
        cityHeading.classList.add('stockist-city-name');
        cityHeading.textContent = city;
        cityContainer.appendChild(cityHeading);

        const stockistListForCity = document.createElement('ul');
        stockistListForCity.classList.add('stockist-list');
        stockistsByCity[city].forEach((stockist) => {
          stockistListForCity.appendChild(renderStockistItem(stockist));
        });
        cityContainer.appendChild(stockistListForCity);
        stockistListContent.appendChild(cityContainer);
      });
    }
  }

  // Default selection logic
  let countryToAutoSelect = null;
  if (hasUnitedStates) {
    countryToAutoSelect = USA;
  } else if (orderedDisplayCountries.length > 0) {
    countryToAutoSelect = orderedDisplayCountries[0];
  }

  if (countryToAutoSelect) {
    const buttonToClick = stockistCountryList.querySelector(
      `.stockist-country-button[data-country="${CSS.escape(countryToAutoSelect)}"]`
    );
    if (buttonToClick) {
      buttonToClick.click();
    } else {
      // Fallback if button not found, though unlikely
      stockistListContent.innerHTML = `<p>${localizedStrings.no_stockists_available}</p>`;
      if (pageTitleElement) pageTitleElement.textContent = originalPageTitle;
    }
  } else {
    // This case implies allCountryNames was empty, already handled, but as a safeguard:
    stockistListContent.innerHTML = `<p>${localizedStrings.no_stockists_available}</p>`;
    if (stockistCountriesContainer) stockistCountriesContainer.style.display = 'none';
    if (pageTitleElement) pageTitleElement.textContent = originalPageTitle;
  }
});
